export default __webpack_public_path__ + "static/media/ic-back-arrow.68d0a04f.svg";